import {CommonService} from '../../services/common.service';
import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ConfirmActionDialogComponent} from '../../common/confirm-action-dialog/confirm-action-dialog.component';
import {CreateNewDialogComponent} from '../create-new-dialog/create-new-dialog.component';
import {MatDialog, MatSnackBar, MatSort, MatTableDataSource} from '@angular/material';
import {SalePoints} from '../../models/SalePoints';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0', visibility: 'hidden'})),
      state('expanded', style({height: '*', visibility: 'visible'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  selector: 'app-nested-table',
  styleUrls: ['./nested-table.component.scss'],
  templateUrl: './nested-table.component.html'
})
export class NestedTableComponent implements OnInit {
  // displayedColumns = ['position', 'name', 'weight'];
  displayedColumns = ['id', 'customer_name', 'postal_code', 'city', 'address', 'phone_number', 'status', 'actions'];
  dataSource: MatTableDataSource<any>;
  elementData: SalePoints[];
  tempElementData: any;
  expandedElement: any;
  @Input() inputData: SalePoints[];
  @Input() type: number;
  @Output() needLoading: EventEmitter<any> = new EventEmitter();
  // @ts-ignore
  @ViewChild(MatSort) sort: MatSort;
  // tslint:disable-next-line:ban-types
  isExpansionDetailRow = (i: number, row: Object) => {
    return row.hasOwnProperty('detailRow');
  }

  constructor(private commonService: CommonService,
              private matDialog: MatDialog,
              private matSnackBar: MatSnackBar) {
  }

  public ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.getRows());
    this.dataSource.sort = this.sort;
  }

  nameComparer(nameA, nameB) {
    if (nameA.element !== undefined) {
      nameA = nameA.element;
    }

    if (nameB.element !== undefined) {
      nameB = nameB.element;
    }

    nameA = nameA.name;
    nameB = nameB.name;

    if (nameA === nameB) {
      return 0;
    }

    if (nameA < nameB) {
      return -1;
    }

    return 1;
  }

  getRows() {
    const rows = [];
    if (this.inputData) {
      this.inputData.forEach(element => {
        element.status = element.is_active === 0 ? 'Ανενεργή' : 'Ενεργή';
        rows.push(element, {detailRow: true, element});
      });
    }
    return rows;
  }

  toggleRow(value: SalePoints) {
    // @ts-ignore
    const foundElement = this.dataSource.data.find(elem => elem.element !== undefined && elem.element.id === value.id);
    // @ts-ignore
    const index = this.dataSource.data.indexOf(foundElement);
    this.dataSource.data[index].element.show = !this.dataSource.data[index].element.show;
  }

  createNewInstallation(edit: boolean, installationId: any) {
    // @ts-ignore
    const installation = installationId ? this.dataSource.data.filter(d => d.id === installationId) : null;
    const dialogReference = this.matDialog.open(CreateNewDialogComponent, {
      panelClass: 'no-padding-dialog',
      data: {
        edit,
        type: this.type,
        installation: edit && this.type === 1 ? installation[0] : null,
        threePL: edit && this.type === 2 ? installation[0] : null
      }
    });

    dialogReference.afterClosed().subscribe(() => {
      this.needLoading.emit(this.type);
    });
  }

  async confirmDeletion(type: number, id: any) {
    const item = this.type === 0 ? 'κατασκευάστρια' : this.type === 1 ? 'εγκατάσταση' : '3PL';
    this.matDialog.open(ConfirmActionDialogComponent, {
      data: {
        confirmFunction: () => {
          this.deActivate({
            id,
            dataSource: this.dataSource.data,
            needsLoading: this.needLoading,
            type: this.type
          });
        },
        message: `Είστε σίγουροι ότι θέλετε να απενεργοποιήσετε την ${item}?`,
        title: 'Απενεργοποίηση'
      }
    });
  }

  async deActivate(object) {
    const items = object.dataSource.filter(d => d.id === object.id);
    const item = items[0];


    const model = {
      id: item.id,
      user_id: item.user_id,
      action: 'delete'
    };
    try {
      await this.commonService.updateObject('sale_point/distribution_center', model);
      object.needsLoading.emit(object.type);
    } catch (e) {
    }
  }

  async Activate(object) {
    const items = object.dataSource.filter(d => d.id === object.id);
    const item = items[0];

    item.action = 'update';

    try {
      await this.commonService.updateObject('sale_point/distribution_center', item);
      object.needsLoading.emit(object.type);
    } catch (e) {
    }
  }

  async updatePlantStorage(element: any, i: number) {
    const item = element.plantStorages[i];
    const model = {
      id: item.id,
      sale_point_id: element.id,
      user_id: element.user_id,
      storage_location: item.storage_location,
      plant: item.plant,
      action: ''
    };
    try {
      if (item.id) {
        model.action = 'update';
        await this.commonService.updateObject('sale_point/distribution_center/plant_storage', model);
        this.openSnackBar('Ενημερώθηκε με επιτυχία');
      } else {
        await this.commonService.insertObject('sale_point/distribution_center/plant_storage', model);
        this.openSnackBar('Αποθηκέυτηκε με επιτυχία');
      }
    } catch (e) {
      this.openSnackBar('Η ενέργεια απέτυχε. ' + e.message);
    }
  }

  openSnackBar(message: string, action?: string) {
    this.matSnackBar.open(message, action, {
      duration: 2000,
    });
  }

  createNewPlatStorageInstallation(id: any) {
    // @ts-ignore
    const item = this.dataSource.data.find(record => record.id === id);
    item.plantStorages.push({id: null, storage_location: '', plant: ''});
  }

  async deletePlantStorage(element: any, i: number) {
    const item = element.plantStorages[i];

    const model = {
      id: element.plantStorages[i].id,
      action: 'delete'
    };

    try {
      await this.commonService.updateObject('sale_point/distribution_center/plant_storage', model);
      item.is_active = 0;
      this.openSnackBar('Η αποθήκη απενεργοποιήθηκε με επιτυχία');
    } catch (e) {
      this.openSnackBar('Σφάλμα κατά την απενεργοποίηση της αποθήκης');
    }
  }

  confirmActivation(type: number, id: any) {
    const item = this.type === 0 ? 'κατασκευάστρια' : this.type === 1 ? 'εγκατάσταση' : '3PL';
    this.matDialog.open(ConfirmActionDialogComponent, {
      data: {
        confirmFunction: async () => {
          await this.Activate({
            id,
            dataSource: this.dataSource.data,
            needsLoading: this.needLoading,
            type: this.type
          });
        },
        message: `Είστε σίγουροι ότι θέλετε να ενεργοποιήσετε την ${item}?`,
        title: 'Ενεργοποίηση'
      }
    });
  }

  getTooltipText(element: any) {
    return element.is_active ? 'Ενεργοποιημένη' : 'Απενεργοποιημένη';
  }

  getIconColor(element: any) {
    return element.is_active ? '#4caf50' : '#dd0330';
  }

  async enablePlantStorage(element: any, i: number) {
    const item = element.plantStorages[i];

    const plantStorage = item;
    plantStorage.action = 'update';

    try {
      await this.commonService.updateObject('sale_point/distribution_center/plant_storage', plantStorage);
      item.is_active = 1;
      this.openSnackBar('Η αποθήκη ενεργοποιήθηκε με επιτυχία');
    } catch (e) {
      this.openSnackBar('Σφάλμα κατά την ενεργοποίηση της αποθήκης');
    }
  }
}


